// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".greet[data-v-d8d6d450]{z-index:100}#bridge-page[data-v-d8d6d450]{position:relative}.circle1[data-v-d8d6d450]{left:-650px}.circle1[data-v-d8d6d450],.circle2[data-v-d8d6d450]{height:1200px;top:-350px;width:1200px}.circle2[data-v-d8d6d450]{right:-650px}.bg[data-v-d8d6d450]{left:0}.bg[data-v-d8d6d450],.bg2[data-v-d8d6d450]{position:absolute;top:50px}.bg2[data-v-d8d6d450]{right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
